import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';

import { IonicModule, ModalController, Platform } from '@ionic/angular';
import {
  PhotoCarouselComponent,
  PhotoCarouselModalComponent,
} from '@smartflip/carousel';
import { DEFAULT_IMAGE_URL } from '@smartflip/data-constants';
import { SwiperPhoto } from '@smartflip/data-models';
import { UploadFormComponent } from './upload-form/upload-form.component';

@Component({
  selector: 'smartflip-property-image',
  templateUrl: './property-image.component.html',
  styleUrls: ['./property-image.component.scss'],
  imports: [IonicModule, PhotoCarouselComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PropertyImageComponent implements OnInit, OnChanges {
  @Input() imgUrl: string = '';
  @Input() useUpload: boolean = false; // turn off upload completely
  @Input() editable: boolean = false; // deprecate this? see logic in OnInit
  @Input() imgClass: string = '';
  @Input() initialSlideIndex: number = 0;
  @Input() propertyId: string = '';
  @Input() propertyPhotos: SwiperPhoto[] = [];
  @Input() disableFullscreen: boolean = false;

  @Output() thumbnailChanged: EventEmitter<string> = new EventEmitter();

  constructor(
    public platform: Platform,
    private modalController: ModalController,
  ) {}

  private setUpView() {
    const shouldNotReplace = this.propertyPhotos?.length > 1; // maybe also confirm that the image is the default

    this.imgUrl = this.imgUrl || DEFAULT_IMAGE_URL;
    this.propertyPhotos =
      this.propertyPhotos?.length > 0 && shouldNotReplace
        ? this.propertyPhotos
        : [{ url: this.imgUrl, alt: 'Home Photo' }];

    if (this.platform.is('cordova')) {
      this.editable = false;
    } else {
      this.editable = true;
    }
  }

  public usingDefaultImage() {
    return this.imgUrl === DEFAULT_IMAGE_URL;
  }

  async uploadImage() {
    const modal = await this.modalController.create({
      component: UploadFormComponent,
      componentProps: {
        propertyId: this.propertyId,
        imgUrl: this.imgUrl,
      },
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.onImageChanged(data);
  }

  async fullScreen() {
    const modal = await this.modalController.create({
      component: PhotoCarouselModalComponent,
      componentProps: {
        photos: this.propertyPhotos,
      },
      cssClass: 'full-screen-modal',
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.onImageChanged(data);
  }

  private onImageChanged(imgUrl: string) {
    if (imgUrl?.length > 0) {
      this.imgUrl = imgUrl || this.imgUrl;
      this.thumbnailChanged.next(imgUrl);
    }
  }

  ngOnInit(): void {
    this.setUpView();
  }

  ngOnChanges(): void {
    this.setUpView();
  }
}
